/**
 * Tiny error boundary used in the Classroom so a video-stack hiccup doesn't
 * blank out the whole page (whiteboard + Leave button must remain usable).
 */
import React from "react";

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.warn("ErrorBoundary caught:", error, info);
  }

  render() {
    if (this.state.error) {
      return (
        this.props.fallback ?? (
          <div
            data-testid="error-boundary-fallback"
            className="w-full h-full flex items-center justify-center bg-black/90 text-white/70 text-sm px-4 text-center"
          >
            <div>
              <div className="opacity-60 text-[10px] tracking-[0.32em] uppercase mb-2">
                Component error
              </div>
              <div className="opacity-80">{String(this.state.error?.message || this.state.error)}</div>
            </div>
          </div>
        )
      );
    }
    return this.props.children;
  }
}
